
export function createUrl(host: string, query_params: Record<string, string | number | boolean>): string {
    const queryParams = new URLSearchParams();
    
    for (const [key, value] of Object.entries(query_params)) {
        queryParams.append(key, String(value));
    }
    
    return `${host}?${queryParams.toString()}`;
}